import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { YOUR_FIREBASE_CONFIG } from "./utils/constants";

let app, db, auth, storage;
let firebaseInitError = null;

try {
    app = initializeApp(YOUR_FIREBASE_CONFIG);
    db = getFirestore(app);
    auth = getAuth(app);
    storage = getStorage(app);
} catch (error) {
    console.error("Failed to initialize Firebase:", error);
    firebaseInitError = `Failed to initialize Firebase: ${error.message}. Please check your Firebase configuration.`;
}

export { app, db, auth, storage, firebaseInitError };
export const appId = YOUR_FIREBASE_CONFIG.projectId;
